﻿

(() => {
    angular.module('fliptoWeb')
        .controller('PartnerSignupCtrl', ['$scope', 'ApiService', '$analytics',
            function ($scope, ApiService, $analytics) {
                "use strict";

                var vm = this;

                var trackingInfo = {
                    submitForm: {
                        eventName: "submitted partner sign up form",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    submitSuccess: {
                        eventName: "successful partner sign up form submit",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    submitFail: {
                        eventName: "failed partner sign up form submit",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    modalAbandon: {
                        submitted: "closed modal after partner sign up form submit",
                        abandon: "hard abandoned partner sign up"
                    }
                }

                vm.firstName = "";
                vm.lastName = "";
                vm.email = "";
                vm.phone = "";
                vm.title = "";
                vm.hotelInfo = "";
                vm.url = "";
                vm.services = "";
                vm.notes = "";

                vm.isCustomer = null;

                vm.isChangingBookingEngine = false;
                vm.isGuestRetargeting = false;
                vm.isEnhancedGuestProfiles = false;
                vm.isIntegratedMarketing = false;

                //This is set to 2 because we don't want the choice active at the moment.
                vm.activeSection = 2;

                vm.activateSection = section => {
                    this.activeSection = section;
                }

                vm.errorMessage = "";

                vm.processingRequest = false;

                vm.hasBeenSubmitted = false;

                vm.trackingInfo = () => {
                    return vm.hasBeenSubmitted ? trackingInfo.modalAbandon.submitted : trackingInfo.modalAbandon.abandon;
                }

                vm.submit = () => {
                    this.errorMessage = "";
                    this.processingRequest = true;

                    $analytics.eventTrack(trackingInfo.submitForm.eventName, trackingInfo.submitForm.eventProperties);

                    var data = {
                        First: this.firstName,
                        Last: this.lastName,
                        Email: this.email,
                        Phone: this.phone,
                        Title: this.title,
                        Company: this.company,
                        Url: this.url,
                        Description: this.notes,
                        ExtendedData: []
                    }

                    if (this.services)
                        data.ExtendedData.push({ Key: "Services-Offered", Value: this.services });

                    if (this.isCustomer != null)
                        data.ExtendedData.push({ Key: "Is-Customer", Value: this.isCustomer });

                    if (this.isChangingBookingEngine)
                        data.ExtendedData.push({ Key: "Interest-Changing-Booking-Engine", Value: this.isChangingBookingEngine });

                    if (this.isGuestRetargeting)
                        data.ExtendedData.push({ Key: "Interest-Guest-Retargeting", Value: this.isGuestRetargeting });

                    if (this.isEnhancedGuestProfiles)
                        data.ExtendedData.push({ Key: "Interest-Enhanced-Guest-Profiles", Value: this.isEnhancedGuestProfiles });

                    if (this.isIntegratedMarketing)
                        data.ExtendedData.push({ Key: "Interest-Integrated-Marketing", Value: this.isIntegratedMarketing });

                    //todo: turn this into a utility service and call it from all contact forms
                    var analyticsData = ((obj) => {
                        var dataObj = {};
                        for (var i in obj) {
                            if (obj.hasOwnProperty(i) && i !== "ExtendedData") {
                                dataObj[i] = data[i];
                            } else if (obj.hasOwnProperty(i) && i === "ExtendedData") {
                                angular.forEach(obj[i], item => {
                                    dataObj[item.Key] = item.Value;
                                });
                            }
                        }
                        return dataObj;
                    })(data);

                    $analytics.setUsername(data.Email || data.First + ' ' + data.Last);
                    $analytics.setUserProperties(analyticsData);

                    ApiService.PartnerSignup_Post(data)
                        .then(response => {
                            if (response.data.Success) {
                                $analytics.eventTrack(trackingInfo.submitSuccess.eventName, trackingInfo.submitSuccess.eventProperties);
                                vm.hasBeenSubmitted = true;
                                vm.activateSection(3);
                            } else {
                                $analytics.eventTrack(trackingInfo.submitFail.eventName, trackingInfo.submitFail.eventProperties);
                                vm.errorMessage = response.data.Message;
                            }
                            vm.processingRequest = false;

                        });
                }

            }]);
})()